import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import './index.css';
import { handleMsalPopupRedirectBridge } from './lib/msal-popup-bridge';
import { trackUserActivity } from './lib/user-activity';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element in document.');
}

void (async () => {
  const handledPopupRedirect = await handleMsalPopupRedirectBridge();
  if (handledPopupRedirect) {
    return;
  }

  // Only requests that follow user input keep the session alive.
  trackUserActivity();
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
})();
